import { CoreOptions as AdyenOptions } from '@adyen/adyen-web/dist/types/core/types';
import dom from '../utils/dom';
import OnePageGivingForm, { StateFilterConfig } from './OnePageGivingForm';
import getCurrencyFormatter from '../tnew/currency/getCurrencyFormatter';
import createRecaptchaWrapper from '../utils/createRecaptchaWrapper';
import PaymentProviderFactory from "../payment/PaymentProviderFactory";

interface OnePageGivingConfig {
  isRecaptchaEnabled: boolean;
  recaptchaSiteKey: string;
  stateFilterConfig?: StateFilterConfig;
  paymentConfiguration: AdyenOptions;
  paymentComponentConfig?: object;
}

const initForm = async (config: OnePageGivingConfig) => {
  const currencyFormatter = await getCurrencyFormatter();
  const captcha = createRecaptchaWrapper(window.grecaptcha, config.isRecaptchaEnabled, config.recaptchaSiteKey);
  const $form = dom.find('.tn-opg-form') as HTMLFormElement;

  let onePageGivingFormInstance: OnePageGivingForm;

  if (config.paymentComponentConfig){
    config.paymentComponentConfig.onAuthorizeFailed = function (event) {
      const responseBody = event.detail.responseBody;
      event.preventDefault();

      onePageGivingFormInstance.onAuthorizeFailed(responseBody);
    }
  }
  
  const paymentComponentConfiguration = config.paymentComponentConfig ? {
    ...config.paymentComponentConfig,
    onSubmit: (state: object) => {},
    onError: (error: object) => {
      console.error(error);
      },
  } : undefined;
  
  const paymentProvider = PaymentProviderFactory.create({
    adyenOptions: config.paymentConfiguration,
    paymentComponentConfiguration,
  });

  onePageGivingFormInstance = new OnePageGivingForm($form, currencyFormatter, captcha, config.paymentConfiguration, config.stateFilterConfig, paymentProvider);
};

window.tnew.page.initialize = (config: OnePageGivingConfig) => {
  window.history.scrollRestoration = 'manual';
  window.addEventListener('unload', () => {});

  initForm(config);
};